import moment from 'moment'
import { REQUEST_PAGE_DEFAULT_HYPERFIND, REQUEST_PAGE_DEFAULT_SELECTED_STATUS } from '../../../constants';

const data = (data = [], action) => {
    switch (action.type) {
        case 'UPDATE_BASE_DATA':
            return [...action.payload]
        case 'UPDATE_MANAGER_DATA':
            return [...action.payload.data]
        default:
            return data
    }
}

const offset = (offset = 0, action) => {
    switch (action.type) {
        case 'UPDATE_MANAGER_DATA':
            return action.payload.offset
        default:
            return offset
    }
}

const dataviewEmployee1Columns = (dataviewEmployee1Columns = [], action) => {
    switch (action.type) {
        case 'UPDATE_DATAVIEW_COLUMNS':
        case 'UPDATE_SELECTED_MANAGER_SETTINGS_AND_DATAVIEW':
        case 'UPDATE_FILTER_DATAVIEW':
            return [...action.payload.dataviewEmployee1Columns]
        default:
            return dataviewEmployee1Columns
    }
}

const dataviewEmployee2Columns = (dataviewEmployee2Columns = [], action) => {
    switch (action.type) {
        case 'UPDATE_DATAVIEW_COLUMNS':
        case 'UPDATE_SELECTED_MANAGER_SETTINGS_AND_DATAVIEW':
        case 'UPDATE_FILTER_DATAVIEW':
            return [...action.payload.dataviewEmployee2Columns]
        default:
            return dataviewEmployee2Columns
    }
}

const dataviewRequestColumns = (dataviewRequestColumns = [], action) => {
    switch (action.type) {
        case 'UPDATE_DATAVIEW_COLUMNS':
        case 'UPDATE_SELECTED_MANAGER_SETTINGS_AND_DATAVIEW':
        case 'UPDATE_FILTER_DATAVIEW':
            return [...action.payload.dataviewRequestColumns]
        default:
            return dataviewRequestColumns
    }
}

const selectedRequests = (selectedRequests = [], action) => {
    switch (action.type) {
        case 'UPDATE_SELECTED_REQUESTS'://not used
            return [...action.payload]
        default:
            return selectedRequests
    }
}

/**
 * Function used to rerender the topbar from the table.js / dataviewTable.js due to a problem with the select all in materialTable
 *
 * See https://dev.azure.com/in-rgy/Airlines/_workitems/edit/4861
 */
const rerenderTopBar = (rerenderTopBar = [], action) => {
    switch (action.type) {
        case 'RERENDER_TOP_BAR':
            return [];
        default:
            return rerenderTopBar;
    }
}

const selectedManagerSetting = (selectedManagerSetting = [], action) => {
    switch (action.type) {
        case 'UPDATE_SELECTED_MANAGER_SETTINGS':
            return [...action.payload]
        case 'CLEAR_FILTERS':
            return []
        case 'INIT_UPDATE':
            return action.payload.selectedManagerSetting

        default:
            return selectedManagerSetting
    }
}

const dataviewsData = (dataviewsData = {}, action) => {
    switch (action.type) {
        case 'UPDATE_SELECTED_MANAGER_SETTINGS_AND_DATAVIEW':
            return { ...action.payload.dataviewsData }
        default:
            return dataviewsData
    }
}

const currentDataview = (currentDataview = {}, action) => {
    switch (action.type) {
        case 'UPDATE_SELECTED_MANAGER_SETTINGS_AND_DATAVIEW':
        case 'UPDATE_FILTER_DATAVIEW':
            return { ...action.payload.currentDataview }
        default:
            return currentDataview
    }
}

const searchQuery = (searchQuery = '', action) => {
    switch (action.type) {
        case 'UPDATE_SEARCH_QUERY':
            return action.payload
        case 'CLEAR_FILTERS':
            return ''
        case 'INIT_UPDATE':
            return action.payload.searchQuery
        default:
            return searchQuery
    }
}

const resetSearchQuery = (resetSearchQuery = false, action) => {
    switch (action.type) {
        case 'INIT_UPDATE':
            return action.payload.resetSearchQuery
        case 'UPDATE_RESET_SEARCH_QUERY':
            return action.payload
        default:
            return resetSearchQuery
    }
}

const selectedStatus = (selectedStatus = [], action) => {
    switch (action.type) {
        case 'UPDATE_SELECTED_STATUS':
            return action.payload
        case 'CLEAR_FILTERS':
            return []
        case 'INIT_UPDATE':
            return action.payload.statusFilterList
        default:
            return selectedStatus
    }
}

const dataviewsList = (dataviewsList = [], action) => {
    switch (action.type) {
        case 'UPDATE_DATAVIEWS_LIST':
            return [...action.payload]
        default:
            return dataviewsList
    }
}

const managerSettingsList = (managerSettingsList = [], action) => {
    switch (action.type) {
        case 'UPDATE_MANAGER_SETTINGS_LIST':
            return [...action.payload]
        case 'INIT_UPDATE':
            return [...action.payload.managerSettingsList]
        default:
            return managerSettingsList
    }
}

const periodSelected = (periodSelected = { name: '' }, action) => {
    switch (action.type) {
        case 'UPDATE_DATES':
        case 'INIT_UPDATE':
            return { ...action.payload.periodSelected }
        default:
            return periodSelected
    }
}

const dateRanges = (dateRanges = { startDate: moment.utc(), endDate: moment.utc() }, action) => {
    switch (action.type) {
        case 'UPDATE_DATES':
        case 'INIT_UPDATE':
            return { ...action.payload.dateRanges }
        default:
            return dateRanges
    }
}

const hyperFindQueries = (hyperFindQueries = [], action) => {
    switch (action.type) {
        case 'INIT_UPDATE':
            return [...action.payload.hyperFindQueries]
        default:
            return hyperFindQueries
    }
}

const ranges = (ranges = null, action) => {
    switch (action.type) {
        case 'INIT_UPDATE':
            return { ...action.payload.ranges }
        default:
            return ranges
    }
}

const periods = (periods = [], action) => {
    switch (action.type) {
        case 'INIT_UPDATE':
            return [...action.payload.periods]
        default:
            return periods
    }
}

const selectedHyperfind = (selectedHyperfind = REQUEST_PAGE_DEFAULT_HYPERFIND, action) => {
    switch (action.type) {
        case 'INIT_UPDATE':
        case 'UPDATE_HYPERFIND_QUERY':
            return { ...action.payload.selectedHyperfind }
        default:
            return selectedHyperfind
    }
}

const searchDateType = (searchDateType = [{ label: "Date submitted ascending", value: 0 }, { label: "Date submitted descending", value: 2 }, { label: "Date requested ascending", value: 1 }, { label: "Date requested descending", value: 3 }]) => {
    return searchDateType
}

const selectedSearchDateType = (selectedSearchDateType = { label: "Date submitted descending", value: 2 }, action) => {
    switch (action.type) {
        case 'UPDATE_SEARCH_DATE_TYPE':
            return { ...action.payload }
        case 'INIT_UPDATE':
            return action.payload.selectedSearchDateType
        default:
            return selectedSearchDateType
    }
}

const fetchSizeOptions = (fetchSizeOptions = [{ label: "5", value: 5 }, { label: "10", value: 10 }, { label: "25", value: 25 }, { label: "50", value: 50 }]) => {
    return fetchSizeOptions
}

const selectedFetchSize = (selectedFetchSize = { label: "10", value: 10 }, action) => {
    switch (action.type) {
        case 'UPDATE_FETCH_SIZE_OPTION':
            return { ...action.payload }
        default:
            return selectedFetchSize
    }
}

const managerRequestsReducers = {
    data,
    dataviewEmployee1Columns,
    dataviewEmployee2Columns,
    dataviewRequestColumns,
    selectedRequests,
    selectedManagerSetting,
    dataviewsData,
    currentDataview,
    searchQuery,
    resetSearchQuery,
    selectedStatus,
    dataviewsList,
    managerSettingsList,
    periodSelected,
    dateRanges,
    hyperFindQueries,
    ranges,
    periods,
    selectedHyperfind,
    searchDateType,
    selectedSearchDateType,
    fetchSizeOptions,
    selectedFetchSize,
    rerenderTopBar,
    offset,
};

export default managerRequestsReducers;
